import { getRealm } from 'utils/storage';

export const parseRealmAllowlist = (envValue) => {
  if (!envValue) return [];
  return String(envValue)
    ?.split(',')
    ?.map((entry) => entry?.trim())
    ?.filter(Boolean);
};

export const isShopifyBinDiscountRealmBypass = () => {
  const realm = getRealm();
  if (!realm) return false;
  const allowed = parseRealmAllowlist(import.meta.env.VITE_BIN_DISCOUNT_SHOPIFY_REALMS);
  const normalizedRealm = String(realm)?.toLowerCase();
  return allowed?.some((entry) => entry?.toLowerCase() === normalizedRealm);
};
